var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropboxLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 30,
    fill: "#0F287F",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.75 23L17.5 29.6176L28.75 36.2353L17.5 42.8529L28.75 49.4706L40 42.8529L51.25 49.4706L62.5 42.8529L51.25 36.2353L62.5 29.6176L51.25 23L40 29.6176L28.75 23ZM40 29.6176L51.25 36.2353L40 42.8529L28.75 36.2353L40 29.6176Z",
    fill: "#DAF8FE",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 53.8824L40 47.2647L51.25 53.8824L40 60.5L28.75 53.8824Z",
    fill: "#DAF8FE",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropboxLight);
export default __webpack_public_path__ + "static/media/dropbox-light.9c989bf0e4c0c433a5a7f78809de7229.svg";
export { ForwardRef as ReactComponent };